import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { TopBar } from "./components/dpm/TopBar";
import { Hero } from "./components/dpm/Hero";
import { WhoWeAre } from "./components/dpm/WhoWeAre";
import { WhyPartner } from "./components/dpm/WhyPartner";
import { PullQuote } from "./components/dpm/PullQuote";
import { MarqueeBand } from "./components/dpm/MarqueeBand";
import { Criteria } from "./components/dpm/Criteria";
import { ContactSection } from "./components/dpm/ContactSection";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.25, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="dpm-page" data-testid="dpm-landing-page">
      <TopBar />
      <main>
        <Hero />
        <WhoWeAre />
        <MarqueeBand />
        <WhyPartner />
        <PullQuote />
        <Criteria />
      </main>
      <ContactSection />
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
